export default __webpack_public_path__ + "static/media/cms-home-preview.779a36bf.jpg";